import React from 'react';
import {
  CartesianGrid,
  LineChart,
  Line,
  YAxis,
  XAxis,
  ReferenceLine,
  BarChart,
  Bar,
} from "recharts";

export const ChartTrackSocialLine = ({ style, values }) => {
  return (
      <LineChart
        className="chart"
        width={280}
        height={150}
        data={values}
        margin={{
          top: 5,
          right: 30,
          left: -25,
          bottom: 5,
        }}
      >
        <CartesianGrid stroke="#ddd" strokeDasharray="3 3" />
        <YAxis tick={{ fontSize: 10, fill: 'gray' }} axisLine={false} tickLine={false} tickFormatter={(value) => new Intl.NumberFormat('en-US', { notation: 'compact' }).format(value)}/>
        <Line strokeWidth={3} type="monotone" dataKey="uv" stroke={style["stroke"]} dot={null} />
      </LineChart>
  );
};

export const ChartTrackSocialBars = ({style, values}) => {
    return (
        <BarChart
          width={280}
          height={100}
          data={values}
          margin={{
            top: 5,
            right: 30,
            left: -25,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis angle={0} tick={{ fontSize: 10, fill: 'darkgray' }}  dataKey="name" />
          <YAxis tick={{ fontSize: 10, fill: 'gray' }} axisLine={false} tickLine={false} tickFormatter={(value) => new Intl.NumberFormat('en-US', { notation: 'compact' }).format(value)} />
          <ReferenceLine y={0} stroke="#ddd" />
          <Bar dataKey="uv"  barSize={20} fill="#82ca9d" />
          <Bar dataKey="pv"  barSize={20} fill="red" />
        </BarChart>
    );
}